
import { Container, Icon } from "@cloudscape-design/components";
import Tabs from "@cloudscape-design/components/tabs";
import React from 'react'
import Charts from "./charts";
import Tabels from "./Tables";
import DetailMap from "./DetailMap";
import MapLibreDetail from "./mapLibreDetail";
import SummaryDetail from "./SummaryDetail";
// import DetailOverview from "./DetailOverview";
import TabAlarm from "./TabAlarm";
import { dataUnit } from "./data/data";



const TabsDetailVehicle = () => {
  return (
    <div style={{ marginTop: "30px" }}>
       
        <Tabs
      
          tabs={[
            {
              label:  (
                <div>
                  <Icon name="search" /> Overview
                </div>
              ),
              id: "first",
              content:  <SummaryDetail/> 
            },
            // {
            //   label: (
            //     <div>
            //       <Icon name="redo" /> TPMS Data
            //     </div>
            //   ),
            //   id: "second",
            //   content:  <Charts />
            // },
            // {
            //   label: ( <div>
            //       <Icon name="status-warning" /> Alert History
            //     </div>
            //   ),
            //   id: "third",
            //   content: <TabAlarm data={dataUnit} />
            // },
            // {
            //   label: ( <div>
            //     <Icon name="flag" /> Tracking
            //   </div>
            // ),
            //   id: "fourth",
            //   content: <MapLibreDetail/>
            // },
            // {
            //   label: ( <div>
            //     <Icon name="file-open" /> Statistic
            //   </div>
            // ),
            //   id: "fifth",
            //   content: "Third tab content area",
            //   disabled: true
            // }
          ]}
        />
    </div>
  )
}

export default TabsDetailVehicle